import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Mic, Loader2 } from "lucide-react";
import api from "@/lib/api";

/** "Practice Interview for This Resume" -- pulls a short AI-ready context string from the
 * learner's saved draft (target role, skills, past titles, summary) and hands it to the
 * Interview Center so mock interview questions are personalized to THIS resume. */
export default function PracticeInterviewCard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const startPractice = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/resume-builder/interview-context");
      if (!data.resume_context) {
        toast.error("Add a Target Role in the Basics step first, then save your draft");
        return;
      }
      navigate("/interview", { state: { resumeContext: data.resume_context, targetRole: data.target_role } });
    } catch {
      toast.error("Could not load your resume context right now");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="glass-panel rounded-2xl p-4" data-testid="ai-tool-card-practice-interview">
      <div className="flex items-center gap-2 mb-1.5">
        <Mic className="w-4 h-4 text-rose-400" />
        <p className="text-sm font-semibold text-white">Practice Interview for This Resume</p>
      </div>
      <p className="text-xs text-slate-400 mb-3">Start a mock interview personalized to your target role, skills, and experience.</p>
      <button
        onClick={startPractice} disabled={loading} data-testid="ai-tool-practice-interview-button"
        className="flex items-center justify-center gap-1.5 w-full bg-rose-500 hover:bg-rose-400 disabled:opacity-60 text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors"
      >
        {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Mic className="w-3.5 h-3.5" />} Practice Now
      </button>
    </div>
  );
}
